export default "__VITE_ASSET__PaT4Ev1f__"